import'string.prototype.startswith';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import NewTobaForm from "../../components/newTobaForm";
import {
    addTobaFormAttachment,
    changeNewTobaProperties,
    changeTobaSettings, closeCreateRevisionConfirmModal,
    closeTobaRevisionModal, closeUpdateTobaConfirmModal,
    getTobaRevisionById,
    openCreateRevisionConfirmModal,
    openTobaRevisionModal, openUpdateTobaConfirmModal,
    populateTobaFormFromRevision,
    removeFetchedTobaAttachment,
    removeTobaFormAttachment,
    requestPostNewToba,
    updateToba
} from "../../actions/toba";
import { goBack } from 'connected-react-router';
import {requestGetGroupsOfSolicitors} from "../../actions/groups";
import {getTobaById} from "../../actions/tobas";
// import download from 'in-browser-download';
import moment from "moment/moment";
import _ from 'lodash';
import {_getFileFromBase64 } from "../../helpers/functions";
import { TOBA_SHORT_TEXT, TOBA_PATH} from '../../helpers/variables';
class TobaFormHOC extends Component {
    

    componentDidMount(){
        if(this.props.routePathname !== ( `/solicitors/${TOBA_PATH}s`) && !this.props.displayInModal){
            let tobaId ;
            let s  = this.props.routePathname.split('/'); 
            tobaId = s[3];
            this.props.getTobaById(tobaId);
        }
        this.props.getSolicitorGroups()
    }

    componentWillReceiveProps(nextProps){
        if((this.props.toba.posting && !nextProps.toba.posting)
            && (nextProps.routePathname !== ( `/solicitors/${TOBA_PATH}s`) && !this.props.displayInModal)
            && (nextProps.toba.successMsg)){
            this.props.goBack();
        }
    }

    _validate = () => {
        if(this.props.toba.fetchingTobaRevisions){
            this.props.changeTobaSettings('failMsg', `${TOBA_SHORT_TEXT} revisions are loading. Please wait.`);
            return false;
        }
        if(!this.props.toba.tobaFormData.version ){
            this.props.changeTobaSettings('failMsg', 'Version is required.');
            return false;
        }
        if(!this.props.toba.tobaFormData.validFrom){
            this.props.changeTobaSettings('failMsg', 'Valid from date is required.');
            return false;
        }
        if(!this.props.toba.changedMadeOnFetchedToba && this.props.routePathname !== ( `/solicitors/${TOBA_PATH}s`) && !this.props.displayInModal){
            this.props.changeTobaSettings('failMsg', `Edit ${TOBA_SHORT_TEXT} to continue.`);
            return false;
        }
        if(!this.props.toba.tobaFormData.defaultToba && _.size(this.props.toba.tobaFormData.selectedSolicitorGroups) === 0){
            this.props.changeTobaSettings('failMsg', 'Select solicitor group(s) to continue.');
            return false;
        }
        if (!this.props.toba.tobaFormData.tobaBody) { //user has not filled the body of the editor?
            this.props.changeTobaSettings('failMsg', `${TOBA_SHORT_TEXT} Content must not be empty.`);
            return false;
        }
        if(!moment(this.props.toba.tobaFormData.validFrom, 'DD/MM/YYYY').isValid()){
            this.props.changeTobaSettings('failMsg', 'Valid from date input is invalid. Date format is: DD/MM/YYYY.');
            return false;
        }
        return true;
    };

    _createToba = () => {
        let validF = moment(this.props.toba.tobaFormData.validFrom, 'DD/MM/YYYY');
        this.props.requestPostNewToba({
            initialRevision: this.props.routePathname !== ( `/solicitors/${TOBA_PATH}s`) && !this.props.displayInModal?this.props.toba.tobaFormData.initialRevision:null,
            validFrom: validF.format(),
            content: this.props.toba.tobaFormData.tobaBody,
            name: this.props.toba.tobaFormData.name,
            version: this.props.toba.tobaFormData.version,
            tobaAttachmentDtos: [...this.props.toba.tobaFormData.attachments, ...this.props.toba.tobaFormData.fetchedTobaAttachments],
            solicitorGroupDtos: _.size(this.props.toba.tobaFormData.selectedSolicitorGroups) === 0?
                null
                :
                _.map(this.props.toba.tobaFormData.selectedSolicitorGroups, g => {
                    return {id: g.id}
                })
        });
    };

    _patchToba = () => {
        let validF = moment(this.props.toba.tobaFormData.validFrom, 'DD/MM/YYYY');
        this.props.updateToba({
            sendBody: {
                id: this.props.toba.tobaFormData.id,
                initialRevision: this.props.routePathname !== (`/solicitors/${TOBA_PATH}s`) && !this.props.displayInModal?this.props.toba.tobaFormData.initialRevision:null,
                validFrom: validF.format(),
                content:  this.props.toba.tobaFormData.tobaBody,
                name: this.props.toba.tobaFormData.name,
                version: this.props.toba.tobaFormData.version,
                tobaAttachmentDtos: [...this.props.toba.tobaFormData.attachments, ...this.props.toba.tobaFormData.fetchedTobaAttachments],
                solicitorGroupDtos: _.size(this.props.toba.tobaFormData.selectedSolicitorGroups) === 0?
                    null
                    :
                    _.map(this.props.toba.tobaFormData.selectedSolicitorGroups, g => {
                        return {id: g.id}
                    })
            },
            tobaId: this.props.toba.tobaFormData.id
        });
    };

    handleSubmit = (evt) => {
        evt.preventDefault();
        let isValid = this._validate();
        if(!isValid) return false;
        if(this.props.toba.tobaFormData.id){
            this.props.openCreateRevisionConfirmModal();
        } else {
            this._createToba();
        }
    };

    _handleUpdate = (evt) => {
        evt.preventDefault();
        let isValid = this._validate();
        if(!isValid) return false;
        this.props.openUpdateTobaConfirmModal();
    };

    onEditorStateChange = (editorState) => {
        this.props.handleInputChange('content', editorState)
    };

    _onDrop = (files) => { //onChange handler for the drop zone component that adds attachments
        for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
            let alreadyExists = false;
            for (let attachmentIndex = 0; attachmentIndex < this.props.toba.tobaFormData.attachments.length; attachmentIndex++) {
                if (files[fileIndex].name === this.props.toba.tobaFormData.attachments[attachmentIndex].name) {
                    alreadyExists = true
                }
            }
            if (!alreadyExists) {
                this._getBase64(files[fileIndex])
            }
            else {
                // console.log('=====already exists =======')
            }
        }
    };

    //function that transforms the input file to base64 format
    _getBase64 = (file) => {
        let reader = new FileReader();
        let attachment = {
            name: file.name,
            encodedFile: '',
            fileType: file.type
        };
        let props = this.props;
        reader.readAsDataURL(file);
        reader.onload = function () {
            attachment = {...attachment, encodedFile: reader.result.substring(reader.result.indexOf("base64,") + 7)};
            props.addTobaFormAttachment(attachment);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };

    _getSelectGroupOptions = () => {
        let options = [];
        try {
            options = this.props.solicitorGroups.map(group => {
                return {
                    key: group.id,
                    name: group.name,
                    value: group,
                }
            });
            if(this.props.toba.tobaFormData.solicitorGroupFilter) {
                options = _.filter(options, o => {
                    return _.lowerCase(o.name).includes(_.lowerCase(this.props.toba.tobaFormData.solicitorGroupFilter))
                })
            }
        }
        catch (e){}
        return options;
    };

    _handleSelectedInputChange = (evt) => {
        if(!evt.target.value){
            this.props.handleInputChange(evt.target.name, evt.target.value);
            this.props.handleInputChange('name', 'Default');
        }
        else {
            if(!this.props.toba.tobaFormData.selectedSolicitorGroup){
                this.props.handleInputChange('name', '');
            }
            this.props.handleInputChange(evt.target.name, evt.target.value);
        }
    };

    _getFileFromBase64 = (documentToDownload) => {
        _getFileFromBase64(documentToDownload)
        // download(documentToDownload.encodedFile, documentToDownload.name, documentToDownload.fileType, 'base64');
    };



    _handleDefaultTobaCheck = (evt) => {
        if(evt.target.checked){
            this.props.handleInputChange('name', 'Default');
            this.props.handleInputChange('checkedSolicitorGroupsIds', []);
            this.props.handleInputChange('selectedSolicitorGroups', {});

        }
        else {
            this.props.handleInputChange('name', '');

        }
        this.props.handleInputChange(evt.target.name, evt.target.checked);
    };

    tobaIsLive = (toba) => {
        if(toba.validFrom && toba.validUntil){
            return moment().isBetween(toba.validFrom, toba.validUntil)
        }
        if(toba.validFrom && !toba.validUntil){
            return moment().isAfter(toba.validFrom)
        }
        return false;
    };

    _futureTobaRevisionsExists = () => {
        const exists = _.find(this.props.toba.previousTobas, t => {
            return moment(moment(t.validFrom)).isAfter(moment(this.props.toba.tobaFormData.validFrom, 'DD/MM/YYYY'))
        });
        return exists;
    };

    _getFutureTobaRevisions = () => {
        const tobas = _.filter(this.props.toba.previousTobas, pT => {
            return moment(moment(pT.validFrom)).isAfter(moment(this.props.toba.tobaFormData.validFrom, 'DD/MM/YYYY'))
        });

        return tobas
    };

    render() {
        return (
            <NewTobaForm
                _getFutureTobaRevisions={this._getFutureTobaRevisions}
                _futureTobaRevisionsExists={this._futureTobaRevisionsExists}
                tobaIsLive={this.tobaIsLive}
                _patchToba={this._patchToba}
                closeUpdateTobaConfirmModal={this.props.closeUpdateTobaConfirmModal}
                _createToba={this._createToba}
                closeCreateRevisionConfirmModal={this.props.closeCreateRevisionConfirmModal}
                getTobaRevisionById={this.props.getTobaRevisionById}
                _handleUpdate={this._handleUpdate}
                _handleDefaultTobaCheck={this._handleDefaultTobaCheck}
                _getFileFromBase64={this._getFileFromBase64}
                _removeFetchedTobaAttachment={this.props.removeFetchedTobaAttachment}
                editingForm={this.props.routePathname !== ( `/solicitors/${TOBA_PATH}s`) && !this.props.displayInModal}
                _handleSelectedInputChange={this._handleSelectedInputChange}
                selectGroupOptions={this._getSelectGroupOptions()}
                _handleCancel={this.props.handleCancel}
                _removeTobaFormAttachment={this.props.removeTobaFormAttachment}
                _onDrop={this._onDrop}
                onEditorStateChange={this.onEditorStateChange}
                goBack={this.props.goBack}
                changeTobaSettings={this.props.changeTobaSettings}
                toba = {this.props.toba}
                handleSubmit = {this.handleSubmit}
                handleInputChange={this.props.handleInputChange}
                populateTobaFormFromRevision={this.props.populateTobaFormFromRevision}
                openTobaRevisionModal={this.props.openTobaRevisionModal}
                closeTobaRevisionModal={this.props.closeTobaRevisionModal}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        toba: state.toba,
        solicitorGroups: state.groups.solicitorGroups.data,
        routePathname: state.router.location.pathname
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleInputChange: (property, value) => {
            dispatch(changeNewTobaProperties(property, value))
        },
        requestPostNewToba: (payload) => {
            dispatch(requestPostNewToba(payload))
        },
        changeTobaSettings: (key, value) => {
            dispatch(changeTobaSettings(key, value))
        },
        goBack: ()=> {
            dispatch(goBack())
        },
        addTobaFormAttachment: (attachement) => {
            dispatch(addTobaFormAttachment(attachement))
        },
        removeTobaFormAttachment: (key) => {
            dispatch(removeTobaFormAttachment(key))
        },
        getSolicitorGroups: () => {
            dispatch(requestGetGroupsOfSolicitors())
        },
        getTobaById: (tobaId) => {
            dispatch(getTobaById(tobaId))
        },
        removeFetchedTobaAttachment: (tobaIndex) => {
            dispatch(removeFetchedTobaAttachment(tobaIndex))
        },
        populateTobaFormFromRevision: (payload) => {
            dispatch(populateTobaFormFromRevision(payload))
        },
        openTobaRevisionModal: (payload) => {
            dispatch(openTobaRevisionModal(payload))
        },
        closeTobaRevisionModal: (payload) => {
            dispatch(closeTobaRevisionModal(payload))
        },
        updateToba: (payload) => {
            dispatch(updateToba(payload))
        },
        getTobaRevisionById: (payload) => {
            dispatch(getTobaRevisionById(payload))
        },
        openCreateRevisionConfirmModal: (payload) => {
            dispatch(openCreateRevisionConfirmModal(payload))
        },
        closeCreateRevisionConfirmModal: (payload) => {
            dispatch(closeCreateRevisionConfirmModal(payload))
        },
        openUpdateTobaConfirmModal: (payload) => {
            dispatch(openUpdateTobaConfirmModal(payload))
        },
        closeUpdateTobaConfirmModal: (payload) => {
            dispatch(closeUpdateTobaConfirmModal(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TobaFormHOC);
